"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('skull', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M11.2631579,44 L14.6270764,35.6852027 C10.0310281,32.5933537 7,27.2926864 7,21.2727273 C7,11.7332634 14.6111593,4 24,4 C33.3888407,4 41,11.7332634 41,21.2727273 C41,27.2926864 37.9689719,32.5933537 33.3729236,35.6852027 L36.7368421,44 L11.2631579,44 Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M20,38 L20,44",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M28,38 L28,44",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("circle", {
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.innerFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin,
    cx: "17",
    cy: "20",
    r: "3"
  }), _react.default.createElement("circle", {
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.innerFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin,
    cx: "31",
    cy: "20",
    r: "3"
  }))));
});

exports.default = _default;